const styles = {
  root: {
    '&.p0': {
      '& .MuiAccordionDetails-root': {
        padding: '0px!important',
      },
    },
  },
  accordionContent: {
    display: 'flex',
    alignItems: 'center',
    '& svg': {
      mr: 1,
    },
  },

  formTitle: {
    '&.MuiTypography-h5': {
      fontWeight: 600,
      fontSize: 14,
      lineHeight: '16px',
    },
  },
  formTitleValid: {
    color: 'text.primaryDark',
  },
  formTitleInvalid: {
    color: 'text.grey800',
  },
  accordionDetails: {
    borderTop: '1px solid #E9E9E9',
  },
}

export default styles
